export const DEFAULT_FONT_FAMILY = 'Arial, sans-serif'
export const DEFAULT_FONT_SIZE = '15pt'
export const DEFAULT_LINE_HEIGHT = '1.4'

const normalizeTypographyStyle = (style) => {
  return style.split(';').map(declaration => {
    const [property, ...valueParts] = declaration.split(':')
    const normalizedProperty = property && property.trim().toLowerCase()
    const value = valueParts.join(':').trim()

    if (normalizedProperty === 'font-family') return `${property.trim()}: ${DEFAULT_FONT_FAMILY}`
    if (normalizedProperty === 'font-size') return `${property.trim()}: ${DEFAULT_FONT_SIZE}`
    if (normalizedProperty === 'line-height') return `${property.trim()}: ${DEFAULT_LINE_HEIGHT}`
    if (normalizedProperty === 'letter-spacing' && value.toLowerCase() === 'normal') return null

    return declaration.trim()
  }).filter(Boolean)
}

export const sanitizeTypographyStyles = (content) => {
  if (!content || typeof document === 'undefined') return content

  const container = document.createElement('div')
  container.innerHTML = content

  container.querySelectorAll('*').forEach(element => {
    Array.from(element.attributes).forEach(attribute => {
      if (attribute.name.startsWith('data-nacs-')) {
        element.removeAttribute(attribute.name)
      }
    })
  })

  container.querySelectorAll('[style]').forEach(element => {
    const styles = normalizeTypographyStyle(element.getAttribute('style'))

    if (styles.length) {
      element.setAttribute('style', styles.join(';'))
    } else {
      element.removeAttribute('style')
    }
  })

  container.querySelectorAll('font').forEach(element => {
    element.removeAttribute('face')
    element.removeAttribute('size')
  })

  return container.innerHTML
}
